
import React from "react";

interface User {
  id?: number;
  nom: string;
  firstname?: string;
}

interface ConfirmDeleteDialogProps {
  user: User | null;
  onCancel: () => void;
  onConfirm: () => void;
  error?: string | null;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  user,
  onCancel,
  onConfirm,
  error,
}) => {
  if (!user) return null;
  return (
    <div
      className="modal show fade d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-danger">Confirmation de suppression</h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            {error && <p className="text-danger">{error}</p>}
            <p>
              Voulez-vous vraiment supprimer{" "}
              <strong>
                {user.nom} {user.firstname}
              </strong>{" "}
              ?
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onCancel}>
              Non
            </button>
            <button className="btn btn-danger" onClick={onConfirm}>
              Oui, supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteDialog;
